import { RfIdTagResponse } from '@gtpl/shared-models/masters';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Get, Post } from '@nestjs/common';

import { AppService } from './app.service';
import { RfidTagRequest } from './racks/dto/rfid-tag.request';

@Controller()
export class AppController {
  constructor(private readonly appService: AppService,
    private readonly applicationExceptionHandler: ApplicationExceptionHandler) {}

  @Get()
  getData() {
    return this.appService.getData();
  }

  /**
    * calling a service to get details for plant and any of the rfid,palletid,rackid
    * @param reqestObj
    * @returns 
    */
   @Post('getRfidTagDetails')
   async getRfidTagDetails(@Body() rfIdTagreqestObj: RfidTagRequest):Promise<RfIdTagResponse> {
       try {
           return await this.appService.getRfidTagDetails(rfIdTagreqestObj);
       } catch (error) {
           return this.applicationExceptionHandler.returnException(RfIdTagResponse, error);
       }
   }
}
